import React from 'react';

const Home = () => {
  return (
    <div className='pa2 '>
     <h1>About page</h1> 
     <p className="f4 tracked light-yellow">Click on tab add robot to begin writing your
      friends name and you get an robot picture with email and an unique id and that
      you can save to remeber your friends!</p>
    </div>
  );
}

export default Home;